import { Link } from 'react-router-dom';
import { routerPaths } from '@ax/constants';
import style from '@/modules/Auth/Login/Login.module.scss';
import classNames from 'classnames';

export interface SupportLinkProps {
  className?: string;
}

export function SupportLink({ className }: Readonly<SupportLinkProps>) {
  return (
    <Link
      to={routerPaths.support}
      className={classNames(style.login__form__body__link, className)}
    >
      Need assistance? Contact support.
    </Link>
  );
}
